export const getSelectedCampaignsGridColumns = (i18n => [{
  key: 'CampaignName',
  name: i18n.getString(_TL_('Campaign name')),
  fieldName: 'Name',
}]);
